<template>
    <div class="tile-container">
        <div class="max-container">
            <div class="row no-gutters">
                <div class="tile-wrapper col-6 col-md-3">
                    <stat-tile
                        class="tile"
                        mobileText="Visits to homepage"
                        text="Visits to homepage"
                        :number="views"
                        icon="monitor"
                        :percent="viewsPercent"
                        :target="viewsTarget"
                        :flip="true"
                        color="teal"
                    ></stat-tile>
                </div>
                <div class="tile-wrapper col-6 col-md-3">
                    <stat-tile
                        class="tile"
                        mobileText="Average time on site"
                        text="Average time<br>spend on site"
                        :time="averageTime"
                        icon="clock"
                        :percent="averageTimePercent"
                        :target="averageTimeTarget"
                        :flip="true"
                        color="pink"
                    ></stat-tile>
                </div>
                <div class="tile-wrapper col-6 col-md-3">
                    <stat-tile
                        class="tile"
                        mobileText="Bounce rate"
                        text="Bounce rate"
                        :number="bounceRate"
                        icon="monitor-bounce"
                        :percent="bounceRatePercent"
                        :target="bounceRateTarget"
                        :flip="true"
                        color="purple"
                        :percentage="true"
                    ></stat-tile>
                </div>
                <div class="tile-wrapper col-6 col-md-3">
                    <stat-tile
                        class="tile"
                        mobileText="Number of conversions"
                        text="Number of conversions"
                        :number="conversions"
                        icon="conversions"
                        :percent="conversionsPercent"
                        :target="conversionsTarget"
                        :flip="true"
                        color="orange"
                    ></stat-tile>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '@/store';
    import StatTile from '@/components/tiles/StatTile';

    export default {
        components: {
            StatTile,
        },
        computed: {
            viewsTarget() {
                if (store.state.websiteData.tiles.viewsTarget) {
                    return store.state.websiteData.tiles.viewsTarget;
                }

                return 0;
            },
            bounceRateTarget() {
                if (store.state.websiteData.tiles.bounceRateTarget) {
                    return store.state.websiteData.tiles.bounceRateTarget;
                }

                return 0;
            },
            conversionsTarget() {
                if (store.state.websiteData.tiles.conversionsTarget) {
                    return store.state.websiteData.tiles.conversionsTarget;
                }

                return 0;
            },
            viewsPercent() {
                if (store.state.websiteData.tiles.viewsPercent) {
                    return store.state.websiteData.tiles.viewsPercent;
                }

                return 0;
            },
            averageTimePercent() {
                if (store.state.websiteData.tiles.averageTimePercent) {
                    return store.state.websiteData.tiles.averageTimePercent;
                }

                return 0;
            },
            bounceRatePercent() {
                if (store.state.websiteData.tiles.bounceRatePercent) {
                    return store.state.websiteData.tiles.bounceRatePercent;
                }

                return 0;
            },
            conversionsPercent() {
                if (store.state.websiteData.tiles.conversionsPercent) {
                    return store.state.websiteData.tiles.conversionsPercent;
                }

                return 0;
            },
            views() {
                if (store.state.websiteData.tiles.views) {
                    return store.state.websiteData.tiles.views;
                }

                return 0;
            },
            bounceRate() {
                if (store.state.websiteData.tiles.bounceRate) {
                    return store.state.websiteData.tiles.bounceRate;
                }

                return 0;
            },
            conversions() {
                if (store.state.websiteData.tiles.conversions) {
                    return store.state.websiteData.tiles.conversions;
                }

                return 0;
            },
            averageTime() {
                if (store.state.websiteData.tiles.averageTime) {
                    const time = store.state.websiteData.tiles.averageTime;

                    const hours = time.h;
                    const minutes = time.m;
                    const seconds = time.s;

                    return {
                        hours,
                        minutes,
                        seconds,
                    };
                }


                return {
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                };
            },
            averageTimeTarget() {
                if (store.state.websiteData.tiles.averageTimeTarget) {
                    const time = store.state.websiteData.tiles.averageTimeTarget;

                    const hours = time.h;
                    const minutes = time.m;
                    const seconds = time.s;

                    return {
                        hours,
                        minutes,
                        seconds,
                    };
                }

                return {
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/partials/variables';

    $margin-amount: 5;
    $margin: #{$margin-amount + 'px'};
    $margin-half: #{($margin-amount / 2) + 'px'};

    $margin-tablet-amount: 9.5;
    $margin-tablet: #{$margin-tablet-amount + 'px'};
    $margin-tablet-half: #{($margin-tablet-amount / 2) + 'px'};

    $margin-desktop-amount: 20;
    $margin-desktop: #{$margin-desktop-amount + 'px'};
    $margin-desktop-half: #{($margin-desktop-amount / 2) + 'px'};

    .tile-container {
        padding-bottom: 43px;
    }

    .tile-wrapper {
        &:nth-child(1) {
            .tile {
                background-color: $tileTeal-background;

                @media screen and (min-width: $tablet) {
                    margin-right: $margin-tablet-half;
                    border-bottom-width: 10px;
                }

                @media screen and (min-width: $desktop) {
                    margin-right: $margin-desktop-half;
                }
            }
        }
        &:nth-child(2) {
            .tile {
                background-color: $tilePink-background;

                @media screen and (min-width: $tablet) {
                    margin-left: $margin-tablet-half;
                    margin-right: $margin-tablet-half;
                }

                @media screen and (min-width: $desktop) {
                    margin-left: $margin-desktop-half;
                    margin-right: $margin-desktop-half;
                }
            }
        }
        &:nth-child(3) {
            .tile {
                background-color: $tilePurple-background;

                @media screen and (min-width: $tablet) {
                    margin-left: $margin-tablet-half;
                    margin-right: $margin-tablet-half;
                }

                @media screen and (min-width: $desktop) {
                    margin-left: $margin-desktop-half;
                    margin-right: $margin-desktop-half;
                }
            }
        }
        &:nth-child(4) {
            .tile {
                background-color: $tileOrange-background;

                @media screen and (min-width: $tablet) {
                    margin-left: $margin-tablet-half;
                }

                @media screen and (min-width: $desktop) {
                    margin-left: $margin-desktop-half;
                }
            }
        }
    }

    .tile {
        position: relative;
        height: 100%;
    }

</style>



// WEBPACK FOOTER //
// src/components/tiles/WebsiteTileContainer.vue